module.exports = __webpack_public_path__ + "static/3-f0b199c4cb2529334561c1d87c826e4b.jpeg";